<template>
  <Tabs :tabTitle='getTitle' :heap="heapAttribute">
    <template v-slot:[i] v-for="(subList, i) in list.sub_nav.item" :key='i'>
      <ul class='sub-items ma-0 pa-0'>
        <li v-for='(item, idx) in subList' :key='idx' class='fs-12 lh-14 mb-12 db hand'>
<!--          <a :href='goToURL(item.url)' @click='openURL'><span class='gray-dark name'>{{item.name}}</span></a>-->
          <router-link :to='goToURL(item.url)' @click='openURL'><span class='name'>{{item.name}}</span></router-link>
        </li>
      </ul>
    </template>
  </Tabs>
</template>

<script>
import Tabs from './Tabs'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

export default {
  name: 'TabsMB',
  components: { Tabs },
  props: ['list'],
  emits: ['openURL'],
  setup(props, { emit }) {
    const route = useRoute()
    const generalStore = useGeneralInfoStore()

    const openURL = () => {
      emit('openURL')
      generalStore.setTabIndex(0)
      const data = {
        status: false,
        statusSubNav: false
      }
      generalStore.setMegaMenuStatusMB(data)

    }

    const heapAttribute = computed(() => {
      const selectedItem = props.list.name
      switch(selectedItem) {
        case "destinations":
          return "browse-destination-submenu"
        case "local designers":
          return "browse-local-designer-submenu"
        case "explore":
          return "browse-explore-submenu"
        default:
          return ""
        }
    })

    const getTitle = computed(() => {
      return props.list.sub_nav.item
    })

    const goToURL = (url) => {
      // Force an absolute path so the link doesn't resolve relative to the current route — from a
      // nested page like /trip-gallery/<trip> a bare "egypt-tours" became /trip-gallery/egypt-tours.
      // Only prepend "/" when it's missing, so an already-absolute url isn't double-slashed.
      const path = url?.startsWith('/') ? url : `/${url}`
      if (route.path !== path) return path
      return route.fullPath
    }

    return {
      openURL, getTitle, goToURL, heapAttribute
    }
  }
}
</script>

<style lang='scss' scoped>
.sub-items {
  li:last-child {
    margin-bottom: 0;
  }
  // v2 §Header Nav sub-link — ink at rest, plain green over 200ms on hover (no underline, no reflow)
  .name {
    color: $foreground;
    transition: color $dur-base $ease-out; // 200ms hover
  }
  a {
    @include focus-ring; // v2 §14 GREEN keyboard ring (was gold)
    &:hover .name { color: $link; }
  }
}
</style>
